import React, { useState, useEffect } from "react";
import "../Cards/DetailCard.scss";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { addliveOneSecKeyarData } from "../../../redux/features/central_monitor/liveOneSecKeyarData";
import keyarData from "../../../redux/features/central_monitor/keyarData";
import DelayedCard from "../Cards/DelayedCard";
import Cookie from "js-cookie";
import axios from "axios";
import urls from "../../../utils/url";

const NavamCard = ({ props, liveBasicDetail, addliveOneSecKeyarData }) => {
  const obj = props;
  const { patientID } = props;

  // console.log(obj);
  // console.log(patientID);

  const cookie = Cookie.get("access_token");
  const cookieData = Cookie.get("data");
  const [keyar, setKeyar] = useState({});
  const [isActive, setIsActive] = useState(true);
  const timestampPerUpdateNavam = 1; // Number of timestamps to display per update
  const updateInterval = 1000;
  const [oneSecKeyarData, setOneSecKeyarData] = useState({});
  const [isDelayedByOneMin, setIsDelayedByOneMin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [patientBasicDetail, setPatientBasicDetail] = useState({});
  const [interpretationsDisable, setInterpretationsDisable] = useState("");
  const [accountType, setAccountType] = useState("");

  // const [spo2UpdateCount, setSpo2UpdateCount] = useState(0);
  // const [pulseUpdateCount, setPulseUpdateCount] = useState(0);

  // useEffect(() => {
  // if (keyar.spo2?.length) {
  //     setSpo2UpdateCount(prev => prev + 1);
  // }
  // }, [keyar.spo2]);

  // useEffect(() => {
  // if (keyar.pulse?.length) {
  //     setPulseUpdateCount(prev => prev + 1);
  // }
  // }, [keyar.pulse]);

    // useEffect(() => {
    // if (keyar.pulse?.length) {
    //     setPulseUpdateCount(prev => prev + 1);
    // }
    // }, [keyar.pulse]);
  
    useEffect(() => {
      if (cookieData) {
        const parsedData = JSON.parse(cookieData);
        // const accessToken = cookieValue.access_token;
        const algorithm = parsedData.fetal_distress_algorithm;
        const account_type = parsedData.account_type;
        setAccountType(account_type); 
        setInterpretationsDisable(algorithm);
      }
    }, [cookieData])
   

  useEffect(() => {
    const data = props.keyarData;
    const patientID = props.patientID;

    if (data !== undefined && data.length > 0) {
      const spo2Value = data.filter((val) => val.param_type == "spo2")[0]
        ?.latest_data;
      const pulseValue = data.filter((val) => val.param_type == "pulse")[0]
        ?.latest_data;
      const hrValue = data.filter((val) => val.param_type == "hr")[0]
        ?.latest_data;
      const rrValue = data.filter((val) => val.param_type == "rr")[0]
        ?.latest_data;
      const tempValue = data.filter((val) => val.param_type == "temp")[0]
        ?.latest_data;

      // Helper function to get latest non-zero value
      const getLatestValue = (dataObj) => {
        if (!dataObj || Object.keys(dataObj).length === 0) return null;
        const validEntries = Object.entries(dataObj)
          .filter(
            ([ts, value]) =>
              value !== "0.0" &&
              value !== 0 &&
              value !== null &&
              value !== undefined,
          )
          .sort(([a], [b]) => parseInt(b) - parseInt(a));
        return validEntries.length > 0 ? parseFloat(validEntries[0][1]) : null;
      };

      // Get latest values for all parameters
      const latestValues = {
        spo2: getLatestValue(spo2Value),
        pulse: getLatestValue(pulseValue),
        hr: getLatestValue(hrValue),
        rr: getLatestValue(rrValue),
        temp: getLatestValue(tempValue),
      };

      // Use SpO2, Pulse, or HR data for timing (whichever has data)
      const timingData =
        spo2Value && Object.keys(spo2Value).length > 0
          ? spo2Value
          : pulseValue && Object.keys(pulseValue).length > 0
            ? pulseValue
            : hrValue && Object.keys(hrValue).length > 0
              ? hrValue
              : null;

      if (!timingData) {
        // If no timing data, just set the latest values without animation
        setKeyar({
          delay: "--",
          spo2: latestValues.spo2,
          pulse: latestValues.pulse,
          hr: latestValues.hr,
          rr: latestValues.rr,
          temp: latestValues.temp,
        });
        return;
      }

      // Convert timing data to sorted arrays for animation
      const sortedTimingData = Object.entries(timingData).sort(
        ([a], [b]) => parseInt(a) - parseInt(b),
      );
      const sortedSpo2Data = spo2Value
        ? Object.entries(spo2Value).sort(
            ([a], [b]) => parseInt(a) - parseInt(b),
          )
        : [];
      const sortedPulseData = pulseValue
        ? Object.entries(pulseValue).sort(
            ([a], [b]) => parseInt(a) - parseInt(b),
          )
        : [];

      let currentIndex = 0;

      const intervalId = setInterval(() => {
        // FIRST get current slices
        const spo2Slice =
          sortedSpo2Data.length > 0
            ? sortedSpo2Data.slice(
                currentIndex,
                currentIndex + timestampPerUpdateNavam,
              )
            : [];

        const pulseSlice =
          sortedPulseData.length > 0
            ? sortedPulseData.slice(
                currentIndex,
                currentIndex + timestampPerUpdateNavam,
              )
            : [];

        // THEN calculate delay from same timestamp as chart layout
        const currentTs =
          spo2Slice[0]?.[0] ||
          pulseSlice[0]?.[0] ||
          sortedTimingData[currentIndex]?.[0];

        if (!currentTs) {
  currentIndex =
    (currentIndex + timestampPerUpdateNavam) %
    sortedTimingData.length;
  return;
}

        const normalizedTs =
          String(currentTs).length === 13
            ? Number(currentTs)
            : Number(currentTs) * 1000;

        const delayInSecs = Math.floor((Date.now() - normalizedTs) / 1000);

        const delay = formatTime(delayInSecs);

        setIsDelayedByOneMin(delayInSecs > 60);

        const spo2Object = convertArrayToObject(spo2Slice);
        const pulseObject = convertArrayToObject(pulseSlice);

        setKeyar({
          delay,
          spo2: spo2Slice,
          pulse: pulseSlice,
          hr: latestValues.hr,
          rr: latestValues.rr,
          temp: latestValues.temp,
        });

        setOneSecKeyarData({
          [patientID]: {
            spo2Dataset: spo2Object,
            pulseDataset: pulseObject,
          },
        });

        currentIndex =
          (currentIndex + timestampPerUpdateNavam) % sortedTimingData.length;
      }, updateInterval);

      return () => clearInterval(intervalId);
    } else if (!data || data.length === 0) {
      addliveOneSecKeyarData({});
    }
  }, [props]);

  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    const paddedMinutes = String(minutes).padStart(2, "0");
    const paddedSeconds = String(remainingSeconds).padStart(2, "0");

    return `${paddedMinutes} min ${paddedSeconds} sec`;
  }

  const convertArrayToObject = (array) => {
    const resultObject = {};
    array.forEach((item) => {
      const [key, value] = item;
      resultObject[key] = value;
    });
    return resultObject;
  };

 useEffect(() => {
  addliveOneSecKeyarData(oneSecKeyarData);
}, [oneSecKeyarData]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${urls.DEV_URL}v1/nurse/patients/?patient_ids=${patientID}&forms=basic_detail&`,
        {
          headers: {
            "Request-ID": "allow|me",
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookie}`,
          },
        },
      )
      .then((res) => {
        if (res.data?.response?.length > 0) {
          const json_data = res.data;
          setPatientBasicDetail(json_data.response[0]?.basic_detail || {});
        } else {
          setPatientBasicDetail({});
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log("Error in Fetching Data", err);
        setError(true);
        setLoading(false);
      });
  }, [patientID]);

  //   console.log(accountType, "Are we in Navam Card")
  //   console.log(keyar.spo2, spo2UpdateCount)
  //   console.log(keyar.pulse, pulseUpdateCount)
  //   console.log(keyar)

  return (
    <>
      <div>
        {obj &&
        obj !== undefined &&
        keyar &&
        Object.keys(keyar).length > 0 &&
        keyar != undefined ? (
          <div>
            <div
              key={obj.patientID}
              index={obj.patientID}
              style={{ marginLeft: 10 }}
              className={"normal_card"}
            >
              <div className="card-top-section">
                <div className="card-header">
                  <p className="name" title={obj.patientName}>
                    {obj.patientName}
                  </p>
                  {accountType && ["Navam"].includes(accountType) && (
                    <img src="/navam-child.svg" alt="Child Image" />
                  )}
                </div>

                <div className="card-header">
                  <p className="patient_id">
                    {interpretationsDisable
                      ? `ID : ${obj.patientID}`
                      : `MRN : ${patientBasicDetail?.mrn || "--"}`}
                  </p>

                  <div className="connected_ellipse">
                    <p className="connected">Connected</p>
                    <div className="ellipse_green"></div>
                  </div>
                </div>
              </div>
              {/* {
                            isDelayedByOneMin ? 
                                <DelayedCard keyar={keyar}/>
                                :  */}
              <div>
                {keyar &&
                Object.keys(keyar).length > 0 &&
                keyar != undefined ? (
                  <div className={"normal_inside_card"}>
                    <div className="logo">
                      <p className={"logo_name"}>Spo2</p>
                      {/* <img src={ '../../fhr.png' } alt="FHR Logo" className='imageLogo'/> */}
                    </div>
                    <div></div>
                    <div className="number-div">
                      <p className={"fhr_number"}>
                        {" "}
                        {keyar.spo2 &&
                        keyar.spo2.length > 0 &&
                        keyar.spo2[0] &&
                        keyar.spo2[0][1] !== "0.0" &&
                        keyar.spo2[0][1] !== "" &&
                        keyar.spo2[0][1] !== undefined
                          ? Math.floor(keyar.spo2[0][1])
                          : "--"}{" "}
                      </p>
                      <p className={"bpm"}>%</p>
                    </div>
                  </div>
                ) : (
                  <div className="normal_inside_card" />
                )}

                {keyar &&
                Object.keys(keyar).length > 0 &&
                keyar != undefined ? (
                  <div className={"normal_inside_card"}>
                    <div className="logo">
                      <p className={"logo_name"}>Pulse Rate</p>
                    </div>
                    <div></div>
                    <div className="number-div">
                      <p className={"fhr_number"}>
                        {" "}
                        {keyar.pulse &&
                        keyar.pulse.length > 0 &&
                        keyar.pulse[0] &&
                        keyar.pulse[0][1] !== "0.0" &&
                        keyar.pulse[0][1] !== "" &&
                        keyar.pulse[0][1] !== undefined
                          ? Math.floor(keyar.pulse[0][1])
                          : "--"}{" "}
                      </p>
                      <p className={"bpm"}>BPM</p>
                    </div>
                  </div>
                ) : (
                  <div className="normal_inside_card" />
                )}
                {keyar &&
                Object.keys(keyar).length > 0 &&
                keyar != undefined ? (
                  <div className={"normal_inside_card"}>
                    <div className="logo">
                      <p className={"logo_name"}>HR</p>
                    </div>
                    <div></div>
                    <div className="number-div">
                      <p className={"fhr_number"}>
                        {" "}
                        {keyar.hr && keyar.hr > 0
                          ? Math.floor(keyar.hr)
                          : "--"}{" "}
                      </p>
                      <p className={"bpm"}>BPM</p>
                    </div>
                  </div>
                ) : (
                  <div className="normal_inside_card" />
                )}
                {keyar &&
                Object.keys(keyar).length > 0 &&
                keyar != undefined ? (
                  <div className={"normal_inside_card"}>
                    <div className="logo">
                      <p className={"logo_name"}>RR</p>
                    </div>

                    <div className="number-div">
                      <p className={"fhr_number"}>
                        {" "}
                        {keyar.rr && keyar.rr > 0 ? Math.floor(keyar.rr) : "--"}
                      </p>
                      <p className={"bpm"}>BPM</p>
                    </div>
                  </div>
                ) : (
                  <div className="normal_inside_card" />
                )}
                {keyar &&
                Object.keys(keyar).length > 0 &&
                keyar != undefined ? (
                  <div className={"normal_inside_card"}>
                    <div className="logo">
                      <p className={"logo_name"}>Temperature</p>
                    </div>

                    <div className="number-div">
                      <p className={"fhr_number"}>
                        {" "}
                        {keyar.temp && keyar.temp > 0
                          ? keyar.temp.toFixed(1)
                          : "--"}
                      </p>
                      <p className={"bpm"}>°C</p>
                    </div>
                  </div>
                ) : (
                  <div className="normal_inside_card" />
                )}
              </div>
              {/* } */}

              <div className="button_div">
                <div className="delayed-div">
                  <p className="delayed"> Delayed By:</p>
                  <p className="time"> - {keyar.delay}</p>
                </div>
                <Link
                  to={{
                    pathname: `/dashboard/navam-central-monitor/graph/${obj.patientID}`,
                    state: { data: keyar },
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="view_button">View</button>
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  liveBasicDetail: state.liveBasicDetail.liveBasicDetail,
});

const mapDispatchToProps = {
  addliveOneSecKeyarData,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavamCard);
